module.exports = __webpack_public_path__ + "img/33_13.660db6a5.png";